<article class="Alert">
	<mat-dialog-content class="Alert__content">
		<section class="Alert__icon Alert__icon--{{ dialogData().type }}">
			<ng-container [ngSwitch]="dialogData().type">
				<ng-container *ngSwitchCase="EAlertType.success">
					<app-icon [icon]="EIcons.circleCheckSolid" iconSize="extraLarge" />
				</ng-container>
				<ng-container *ngSwitchCase="EAlertType.error">
					<app-icon [icon]="EIcons.circleXmarkSolid" iconSize="extraLarge" />
				</ng-container>
				<ng-container *ngSwitchCase="EAlertType.warning">
					<app-icon [icon]="EIcons.circleExclamationSolid" iconSize="extraLarge" />
				</ng-container>
				<ng-container *ngSwitchCase="EAlertType.info">
					<app-icon [icon]="EIcons.circleInfoSolid" iconSize="extraLarge" />
				</ng-container>
				<ng-container *ngSwitchDefault>
					<app-icon [icon]="EIcons.circleCheckSolid" iconSize="extraLarge" />
				</ng-container>
			</ng-container>
		</section>
		<p class="Alert__message">
			{{ dialogData().message }}
		</p>
	</mat-dialog-content>
	<mat-dialog-actions
		class="Alert__actions"
		[class.Alert__actions--has-cancel]="dialogData().hasCancelButton"
	>
		<app-button
			*ngIf="dialogData()?.hasCancelButton"
			color="red"
			[outline]="true"
			[isFull]="true"
			(clicked)="onCloseDialog({ isSuccess: false })"
		>
			Cancelar
		</app-button>
		<app-button
			[color]="dialogData().type === EAlertType.error ? 'red' : 'green'"
			[isFull]="true"
			(clicked)="onCloseDialog({ isSuccess: true })"
		>
			{{ dialogData().successButtonText ? dialogData().successButtonText : 'Aceptar' }}
		</app-button>
	</mat-dialog-actions>
</article>

